/* unplugin-vue-components disabled */import { render } from "./dragcontent.vue?vue&type=template&id=53f5eb2e&scoped=true"
import script from "./dragcontent.vue?vue&type=script&lang=js"
export * from "./dragcontent.vue?vue&type=script&lang=js"

import "./dragcontent.vue?vue&type=style&index=0&id=53f5eb2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f5eb2e"]])

export default __exports__